










































import {Vue, Component, Ref, Prop, PropSync} from 'vue-property-decorator';
import { CollapseTransition } from "vue2-transitions";
import {notifyError} from "@/utils/notify-helper";
import { InputWings } from "wings-ui-components";

@Component({components: {CollapseTransition, InputWings}})
export default class SaveTemplate extends Vue {
  @Ref('validator') validator: any;
  @PropSync('show') is_show!: boolean;
  @Prop() itemId!: number;
  @Prop({default: "template"}) type!: string;

  name = null

  async save() {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return
    }
    this.$emit('save', this.name)
    this.name = null
    // this.is_show = false
  }

  async update() {
    this.$emit('update')
  }

}
